import { useEffect, useMemo, useState } from "react";
import DealFieldsProvider from "../services/dealFieldsProvider";
import PipedriveApiService from "../services/pipedriveApiService";

export default function usePipedriveOrganizationSearch(query: string): string[] {
    const pipedriveApiService = useMemo(() => new PipedriveApiService(new DealFieldsProvider()), []);
    const [searchResult, setSearchResult] = useState<string[]>([]);

    useEffect(() => {
        setSearchResult([]);
        if (query.length < 3) {
            return;
        }

        let isRequestCancelled = false;
        pipedriveApiService.searchOrganizations(query)
            .then(organizations => !isRequestCancelled && setSearchResult(organizations.map(o => o.name)));

        return () => {
            isRequestCancelled = true;
        };
    }, [query]);

    return searchResult;
}